import {font_s_lg} from '../../../../styleGuide';
import {clearfix} from '../../../../globalStyles';
import colors from '../../../../colors';
const shadow = {
  position: 'absolute',
  width: '100%',
  height: '1px',
  top: 0,
  transform: 'translateY(-1px)',
  display: 'block',
  boxShadow: '0 2px 8px rgba(0,0,0,0.5)',
};
const dimensions = {
  height: '520px',
  maxHeight: '100%',
}

export default {
  // container
  containerWrapper: {
    ...dimensions,
    overflow: 'hidden',
    position: 'relative',
    marginBottom: '8px',
  },
  container: {
    position: 'relative',
    ...dimensions,
    overflowY: 'auto',
    overflowX: 'hidden',
    background: 'rgba(0,0,0,0.04)',
    border: '1px solid ' + colors.xdFadedBlue,
    borderRadius: '3px',
  },

  // shadows
  topShadow: {
    ...shadow,
  },
  bottomShadow: {
    ...shadow,
    top: 'auto',
    bottom: 0,
    transform: 'translateY(1px)',
    boxShadow: '0 -2px 8px rgba(0,0,0,0.5)',
  },

  // message list
  messagesWrapper: {
    ...clearfix,
    padding: '8px'
  },

  // system message
  systemMessageContainer: {
    ...font_s_lg,
    fontWeight: 'bold',
    maxWidth: '320px',
    width: '90%',
    textAlign: 'center',
    margin: '0 auto 32px',
    colors: colors.gray ,
  }
};
